import React from 'react';
import { TutorialPage } from '../TutorialPage';
import { TooltipPosition } from '../../../types/tutorial';

export interface CategoryPageProps {
  currentPage: number;
  totalPages: number;
  onNext: () => void;
  onPrevious: () => void;
  onSkip: () => void;
  onFinish: () => void;
  targetId?: string;
  tooltipPosition?: TooltipPosition;
}

/**
 * Tutorial Page 2: Choose a Category
 * Tooltip positions relative to categories-section element (in sub-header on desktop)
 */
export const CategoryPage: React.FC<CategoryPageProps> = ({
  targetId = 'categories-section',
  tooltipPosition = 'bottom', // Changed from 'right' to 'bottom' for sub-header
  ...props
}) => {
  return (
    <TutorialPage
      title="Choose a Category"
      subtitle="Start your stock guessing game journey! Even hedge funds are divided into areas of expertise – no single analyst is across the whole market!"
      targetId={targetId}
      tooltipPosition={tooltipPosition}
      {...props}
    >
      <div />
    </TutorialPage>
  );
};

export default CategoryPage;
